/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Footer_NavigateInputs */

const en_footer_navigate = /** @type {(inputs: Footer_NavigateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`navigate`)
};

const ar_footer_navigate = /** @type {(inputs: Footer_NavigateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تنقّل`)
};

const bn_footer_navigate = /** @type {(inputs: Footer_NavigateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`নেভিগেশন`)
};

const de_footer_navigate = /** @type {(inputs: Footer_NavigateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`navigieren`)
};

const es_footer_navigate = /** @type {(inputs: Footer_NavigateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`navegar`)
};

const fr_footer_navigate = /** @type {(inputs: Footer_NavigateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`naviguer`)
};

const pt_footer_navigate = /** @type {(inputs: Footer_NavigateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`navegar`)
};

const zh_footer_navigate = /** @type {(inputs: Footer_NavigateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`导航`)
};

const tr_footer_navigate = /** @type {(inputs: Footer_NavigateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`gezin`)
};

const ru_footer_navigate = /** @type {(inputs: Footer_NavigateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`перейти`)
};

const pl_footer_navigate = /** @type {(inputs: Footer_NavigateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`nawiguj`)
};

/**
* | output |
* | --- |
* | "navigate" |
*
* @param {Footer_NavigateInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const footer_navigate = /** @type {((inputs?: Footer_NavigateInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Footer_NavigateInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_footer_navigate(inputs)
	if (locale === "bn") return bn_footer_navigate(inputs)
	if (locale === "de") return de_footer_navigate(inputs)
	if (locale === "es") return es_footer_navigate(inputs)
	if (locale === "fr") return fr_footer_navigate(inputs)
	if (locale === "pt") return pt_footer_navigate(inputs)
	if (locale === "zh") return zh_footer_navigate(inputs)
	if (locale === "tr") return tr_footer_navigate(inputs)
	if (locale === "ru") return ru_footer_navigate(inputs)
	if (locale === "pl") return pl_footer_navigate(inputs)
	return en_footer_navigate(inputs)
});